import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import theme from '@vr/lib/styles/theme';
import { TextField } from '~/elements';
import MapLoader from '~/components/MapLoader';
import { convertGoogleResponseToAddress } from '~/helpers/google';

const StyledTextField = styled(TextField)`
  margin-bottom: 0;

  .MuiInputLabel-root {
    color: ${({ theme }) => theme.colors.gray400} !important;
  }
  .MuiInputBase-input {
    color: ${({ theme }) => theme.colors.gray400} !important;
  }
`;

const suggestionsStyles = {
  container: {},
  suggestion: {
    border: `1px solid ${theme.colors.gray100}`,
    borderTop: 0,
    color: theme.colors.gray400,
    fontSize: 13,
    fontWeight: 100,
  },
};

const autocompleteRequestConfig = {
  componentRestrictions: {
    country: 'br',
  },
};

const TextFieldGoogleAutocomplete = forwardRef(
  ({ label, messageError, name, debounce, onSelect, ...rest }, ref) => {
    async function handleOnSelect(place) {
      const resultado = { success: false };
      try {
        if (!window.mapa) {
          const element = document.createElement('div');
          window.mapa = new window.google.maps.Map(element);
        }

        const placesService = new window.google.maps.places.PlacesService(
          window.mapa,
        );

        const request = {
          placeId: place.place_id,
          sessionToken: autocompleteRequestConfig.sessionToken,
          fields: ['address_components', 'formatted_phone_number', 'geometry'],
        };

        placesService.getDetails(request, (response, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const endereco = convertGoogleResponseToAddress(place, response);

            if (onSelect) {
              onSelect({ ...endereco, success: true });
            }
            return;
          }

          if (onSelect) {
            onSelect(resultado);
          }
        });
      } catch (e) {
        if (onSelect) {
          onSelect(resultado);
        }
      }
    }

    return (
      <GooglePlacesAutocomplete
        placeholder=""
        autocompletionRequest={autocompleteRequestConfig}
        onSelect={handleOnSelect}
        debounce={debounce}
        suggestionsStyles={suggestionsStyles}
        loader={<MapLoader />}
        minLengthAutocomplete={4}
        renderInput={props => (
          <StyledTextField
            fullWidth
            ref={ref}
            name={name}
            label={label}
            messageError={messageError}
            {...props}
          />
        )}
        {...rest}
      />
    );
  },
);

TextFieldGoogleAutocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  messageError: PropTypes.string,
  onSelect: PropTypes.func,
  debounce: PropTypes.number,
};

TextFieldGoogleAutocomplete.defaultProps = {
  messageError: null,
  onSelect: null,
  debounce: 500,
};

export default TextFieldGoogleAutocomplete;
